import { render } from "./TooltipComponent.vue?vue&type=template&id=5fd5e7d6&scoped=true"
import script from "./TooltipComponent.vue?vue&type=script&lang=js"
export * from "./TooltipComponent.vue?vue&type=script&lang=js"

import "./TooltipComponent.vue?vue&type=style&index=0&id=5fd5e7d6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd5e7d6"]])

export default __exports__